export enum PlanStatus {
  GatheringInfo = 'GatheringInfo',
  AwaitingApproval = 'AwaitingApproval',
  ReadyToExecute = 'ReadyToExecute',
  InProgress = 'InProgress',
  AwaitingUserFeedback = 'AwaitingUserFeedback',
  SuccessfullyCompleted = 'SuccessfullyCompleted',
  Failed = 'Failed',
}

export enum PlanStepStatus {
  Pending = 'Pending',
  InProgress = 'InProgress',
  AwaitingUserFeedback = 'AwaitingUserFeedback',
  SuccessfullyCompleted = 'SuccessfullyCompleted',
  Failed = 'Failed',
}

export enum PlanToolName {
  CreatePlan = 'create-plan',
  UpdatePlanExecution = 'update-plan-execution',
  UpdatePlanExecutionSimple = 'update-plan-execution-simple',
}

export enum PlanCollapseState {
  Expanded = 'Expanded',
  CollapsingInProgress = 'CollapsingInProgress',
  Collapsed = 'Collapsed',
}
